import { render, staticRenderFns } from "./ModalViedo.vue?vue&type=template&id=63f263bf&lang=pug&"
import script from "./ModalViedo.vue?vue&type=script&lang=js&"
export * from "./ModalViedo.vue?vue&type=script&lang=js&"
import style0 from "./ModalViedo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports